import { render, staticRenderFns } from "./BrandSlide.vue?vue&type=template&id=26d12c31&scoped=true&"
import script from "./BrandSlide.vue?vue&type=script&lang=js&"
export * from "./BrandSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d12c31",
  null
  
)

export default component.exports